import { render, staticRenderFns } from "./UserWizardFinish.vue?vue&type=template&id=471d080c&"
import script from "./UserWizardFinish.vue?vue&type=script&lang=js&"
export * from "./UserWizardFinish.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports